import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

const MOBILE_QUERY = '(max-width: 768px)'
const MIN_SCROLL = 500

// Barra fixa de compra: só no celular, na home, depois do topo e fora da seção de preços
const useShowStickyCta = () => {
  const { pathname } = useLocation()
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (pathname !== '/') {
      setShow(false)
      return
    }

    const mq = window.matchMedia(MOBILE_QUERY)

    const update = () => {
      const pricing = document.getElementById('pricing')
      let pricingVisible = false
      if (pricing) {
        const r = pricing.getBoundingClientRect()
        pricingVisible = r.top < window.innerHeight && r.bottom > 0
      }
      setShow(mq.matches && window.scrollY > MIN_SCROLL && !pricingVisible)
    }

    update()
    window.addEventListener('scroll', update, { passive: true })
    window.addEventListener('resize', update)
    return () => {
      window.removeEventListener('scroll', update)
      window.removeEventListener('resize', update)
    }
  }, [pathname])

  return show
}

export default useShowStickyCta
